import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DoorBackIcon(props: IconProps) {
    return <Icon {...props} iconKey={"door_back"}/>
}
